<div
  #item
  [queryParams]="params" [routerLinkActive]="'active-nav-item'" [routerLink]="link"
  class="flex flex-row items-center px-1.5 py-0.5 space-x-1.5 cursor-pointer select-none transition-all duration-200 group relative rounded-lg hover:bg-white hover:shadow-sm">

  <div
    class="flex items-center justify-center w-5 h-5 text-gray-400 group-hover:text-theme-primary-500 transition-colors duration-200">
    <div class="w-3.5 h-3.5 flex items-center justify-center">
      <ng-content></ng-content>
    </div>
  </div>

  <span
    class="text-[11px] font-medium text-gray-500 group-hover:text-gray-900 transition-colors tracking-tight whitespace-nowrap leading-tight">
    {{ title }}
  </span>

  <!-- Status badge (#224). Deliberately NOT the large entry's tile-anchored treatment. There is no tile here to
       anchor to — the compact entry's icon has no background square, it is a bare 20 px box in a flex ROW — and a
       pill straddling the top edge of a 20 px icon would be taller than the icon itself, overhang the label
       beside it, and collide with the neighbouring row in the stacked sub-entry lists (`py-0.5` per row). So the
       badge rides inline after the label instead: it reflows naturally, is announced in reading order, and needs
       no headroom from its ancestors. `nav-badge` keeps it out of the `.active-nav-item` label override — here it
       IS a direct <span> child, unlike on the large entry. Contrast 5.14:1. -->
  @if (badge(); as badgeLabel) {
    <span
      class="nav-badge rounded-full bg-theme-primary-100 px-1 py-px text-[9px] font-bold uppercase tracking-wide
             text-theme-primary-700 ring-1 ring-theme-primary-200 whitespace-nowrap leading-none">
      {{ badgeLabel }}
    </span>
  }
</div>
